import { imageNames } from "./imageConstants.js";

export const characterLimitStates = {
  error: {
    condition: (charCount, maxLimit) => charCount > maxLimit,
    message: "Maximum character limit exceeded!",
    messageClass: "error_message_color",
    countClass: "error_message_color",
    icon: imageNames.RED_INFO,
    alt: "warning",
  },
  caution: {
    condition: (charCount, cautionLimit, maxLimit, cautionText) =>
      charCount > cautionLimit && charCount <= maxLimit && cautionText,
    message: (cautionText) => cautionText,
    messageClass: "caution_message_color",
    countClass: "caution_message_color",
    icon: imageNames.YELLOW_WARNING,
    alt: "caution",
  },
  normal: {
    condition: () => true,
    message: null,
    messageClass: "",
    countClass: "secondary_color",
    icon: null,
    alt: "",
  },
};

export const approvalMessages = {
  characterLimitExceeded:
    "Maximum character limit exceeded! Reduce characters to save & continue",
};
